import NoteDetails from './NoteDetails';

export default NoteDetails;
